import ParaModel from '@ParaModel';
import FireStore from '@FireStore';
import QuillLocalStorage from 'core/utils/localStorageClient';
import Track from 'src/paraphraser/handlers/track';
import { getReduxStore } from 'src/_common/redux/store';

const LocalStorage = QuillLocalStorage.getInstance();

function handleInputSubmitEvent(eventName: string, eventCount: number) {
  const localStorageSegmentClickedCount = +LocalStorage.get('segmentClickedCount') || 0;
  let segmentClickedCount =
    <number>getReduxStore()?.getState()?.user?.count?.segmentClickedCount || 0;

  const actualSegClickedCount = Math.max(segmentClickedCount, localStorageSegmentClickedCount);

  if (actualSegClickedCount < 1) {
    if ([3, 10, 20].includes(eventCount)) {
      // @ToDo we are re - assing to show help value, fix in future;
      ParaModel.showHelp = {
        ...ParaModel.showHelp,
        [eventName]: true,
      };
      Track.shownThesaurusHelp({
        submittedInputCount: eventCount,
        segmentClickedCount: actualSegClickedCount,
      });
      // ParaModel.update(0);
      //   Cookies.set();
    }
  }
}

function showHelp(eventName: string) {
  const countVar = `${eventName}Count`;
  let count = getReduxStore()?.getState()?.user?.count
    ? <number>getReduxStore()?.getState()?.user?.count[countVar]
    : 0;
  const varLocalStorageCount = +LocalStorage.get(countVar) || 0;
  count = Math.max(count, varLocalStorageCount) + 1;
  // set this number to cookies for future use
  LocalStorage.set(countVar, `${count}`);
  switch (eventName) {
    case 'submittedInput':
      handleInputSubmitEvent(eventName, count);
      break;
  }
}

export default showHelp;
